export default {
  functionKey: "MIN",
  title: "MIN",
  group: "Calcul",
  origin: [],
  target: [],
  targetRequired: true,
  multiOrigin: true,
  description: "Retourne la valeur minimale parmi plusieurs colonnes pour chaque ligne. Ajoutez les colonnes en Origine.",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol, allOrigins = []) {
    const cols = allOrigins.length > 0 ? allOrigins : (origin ? [origin] : []);
    if (cols.length === 0) return { displayCode: '', safeCode: '' };
    const safeCode = `var _mn=[${cols.join(',')}].map(function(v){return parseFloat(v);}).filter(function(v){return !isNaN(v);}); ${destination}=_mn.length>0?String(Math.min.apply(null,_mn)):'';`;
    return { displayCode: safeCode, safeCode };
  }
}
